import get from 'lodash/get';
import invoke from 'lodash/invoke';

const getBBid = (server, keepMeLoggedIn) => {
    const bbId = !server && get(invoke(window, 'IGLOO.getBlackbox'), 'blackbox');
    const customHeaders = {
        ...(bbId && { 'X-BLACKBOX': bbId }),
        'X-KEEP-ME-SIGNED': keepMeLoggedIn,
    };
    return customHeaders;
};

export default getBBid;
